module.exports = __webpack_public_path__ + "img/reason_02@2x.269686d3.png";